"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var CodebookItem_1 = require("./codebook/CodebookItem");
/**
 * Codebook represents units like kg (kilogram), l (litre) or pc (piece).
 * @author VRu
 */


var Unit =
/*#__PURE__*/
function (_CodebookItem_1$Codeb) {
  _inherits(Unit, _CodebookItem_1$Codeb);

  /**
   * @param id
   * @param title the title of the format
   * @param externalId the external id
   */
  function Unit(id, title, externalId) {
    var _this;

    _classCallCheck(this, Unit);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Unit).call(this, id, title, null, immutable_1.List(), externalId));
    _this.id = id;
    _this.title = title;
    _this.externalId = externalId;
    return _this;
  }

  return Unit;
}(CodebookItem_1.CodebookItem);

exports.Unit = Unit;
/** Name of codebook for generic codebook API, not lookup sequence. */

Unit.CODEBOOK_NAME = 'units';